"use client";

// HeroUI provider import
import { HeroUIProvider } from "@heroui/react";
import { PostHogProvider } from "./posthog-provider";
import { ThemeProvider } from "./theme-provider";

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <PostHogProvider>
      <ThemeProvider><HeroUIProvider>{children}</HeroUIProvider></ThemeProvider>
    </PostHogProvider>
  );
}
